import { createSlice } from "@reduxjs/toolkit";

const initialState = null;

const usersFiltersSlice = createSlice({
  name: "usersFilters",
  initialState,
  reducers: {
    setUsersFilters: (state, action) => action.payload,
    clearUsersFilters: () => null,
  },
});

export const { setUsersFilters, clearUsersFilters } =
  usersFiltersSlice.actions;
export default usersFiltersSlice.reducer;
